const throttle = function (_func, _delay) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        if (!timeout) {
            timeout = setTimeout(() => {
                timeout = null;
                _func.apply(context, args);
            }, _delay);
        }
    };
};
export default throttle;
